const utils = {
    methods: {
        radiansToDegrees(radians) {
            return radians * (180 / Math.PI);
        },
        saveAndContinue(label, value, next){
            sessionStorage.setItem(label, value);
            //this.$router.push(next);
            const newPath = this.$router.resolve(next).href;
            window.location.href = newPath;
            
        }
    }
}

export default utils